// extracted by mini-css-extract-plugin
module.exports = {"table":"cookie-policy-table_table__3WnVn","small":"cookie-policy-table_small__JY6FI"};